function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M368.801,149.698c0-3.731-2.394-7.045-5.934-8.224l-104.107-34.702c-1.779-0.599-3.704-0.599-5.483,0l-104.107,34.702 c-3.54,1.18-5.934,4.494-5.934,8.224v128.564c-0.13,36.186,20.336,69.292,52.756,85.359l56.149,28.126 c2.438,1.223,5.318,1.223,7.756,0l56.149-28.083c32.438-16.076,52.904-49.199,52.756-85.403L368.801,149.698L368.801,149.698z  M351.45,236.454h-86.756V127.028l86.756,28.924V236.454z M247.342,127.028v109.426h-86.756v-80.501L247.342,127.028z  M160.586,278.262v-24.457h86.756v116.097L203.747,348.1C177.217,334.957,160.482,307.863,160.586,278.262z M308.288,348.1 l-43.595,21.802V253.805h86.756v24.457C351.554,307.863,334.81,334.957,308.288,348.1z"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 247.342,
  y: 36.915,
  width: 17.351,
  height: 17.351
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M505.008,443.532l-28.092-5.622l-28.803-28.812l18.401-18.41c3.383-3.383,3.383-8.884,0-12.267l-24.535-24.543 c-3.383-3.383-8.884-3.383-12.267,0l-6.142,6.142l-30.252-30.252c6.732-16.614,10.185-34.364,10.185-52.288V167.665l75.539-75.539 c1.631-1.622,2.542-3.835,2.542-6.134V36.915c0-4.789-3.887-8.676-8.676-8.676H423.83c-2.299,0-4.511,0.911-6.134,2.542 l-69.292,69.292l-8.606-2.681l28.534-83.711c1.544-4.537-0.885-9.465-5.422-11.009c-0.894-0.304-1.839-0.46-2.785-0.46h-34.702 c-2.733,0-5.301,1.284-6.94,3.47l-19.086,25.446L280.31,5.683c-1.64-2.186-4.208-3.47-6.94-3.47h-34.702 c-2.733,0-5.301,1.284-6.94,3.47L212.64,31.128L193.553,5.683c-1.64-2.186-4.208-3.47-6.94-3.47h-34.702 c-4.789,0-8.676,3.887-8.667,8.684c0,0.946,0.156,1.891,0.46,2.785l28.534,83.711l-8.606,2.681L94.339,30.781 c-1.622-1.631-3.835-2.542-6.134-2.542H39.128c-4.789,0-8.676,3.887-8.676,8.676v49.078c0,2.299,0.911,4.511,2.542,6.134 l75.539,75.539v109.816c0,17.924,3.453,35.674,10.185,52.288l-30.252,30.252l-6.142-6.142c-3.444-3.253-8.823-3.253-12.267,0 l-24.535,24.543c-3.383,3.383-3.383,8.884,0,12.267l18.401,18.41l-28.82,28.812l-28.074,5.622c-4.537,0.876-7.591,5.162-6.94,9.734 l6.134,42.936c0.547,3.817,3.548,6.819,7.366,7.366l42.936,6.134c4.555,0.651,8.832-2.377,9.734-6.888l5.622-28.092l28.846-28.82 l18.41,18.41c3.383,3.383,8.884,3.383,12.267,0l24.535-24.543c3.383-3.383,3.383-8.884,0-12.267l-6.134-6.142l25.359-25.35 c3.279,1.987,6.628,3.895,10.107,5.63l66.872,33.488c2.438,1.223,5.318,1.223,7.756,0l66.872-33.444 c3.47-1.735,6.828-3.644,10.107-5.63l25.359,25.35l-6.134,6.142c-3.383,3.383-3.383,8.884,0,12.267l24.535,24.543 c3.383,3.383,8.884,3.383,12.267,0l18.41-18.453l28.812,28.82l5.622,28.092c0.902,4.511,5.179,7.539,9.734,6.888l42.936-6.134 c3.817-0.547,6.819-3.548,7.366-7.366l6.134-42.936C512.564,448.703,509.528,444.426,505.008,443.532z M411.311,372.288 l-12.267,12.267l-23.424-23.424c3.566-4.702,6.819-9.63,9.743-14.749L411.311,372.288z M402.41,119.68l25.012-25.012h24.543 l-48.462,48.462v-19.459C403.469,122.274,403.096,120.903,402.41,119.68z M464.233,77.317h-31.727V45.59h31.727V77.317z  M415.155,57.858v24.543l-29.358,29.358l-18.731-5.839L415.155,57.858z M164.056,19.564h18.219l23.424,31.232 c3.158,3.835,8.814,4.381,12.649,1.232c0.451-0.373,0.859-0.781,1.232-1.232l23.424-31.232h26.027l23.424,31.232 c3.158,3.835,8.814,4.381,12.649,1.232c0.451-0.373,0.859-0.781,1.232-1.232l23.424-31.232h18.219l-24.769,72.65l-64.59-20.197 c-1.692-0.538-3.514-0.538-5.205,0l-64.633,20.197L164.056,19.564z M126.239,111.759L96.881,82.401V57.858l48.054,48.063 L126.239,111.759z M79.53,45.59v31.727H47.803V45.59H79.53z M60.07,94.668h24.543l25.012,25.012 c-0.685,1.223-1.058,2.594-1.093,3.991v19.459L60.07,94.668z M126.725,346.261c2.924,5.119,6.177,10.046,9.743,14.749 l-23.424,23.424l-12.319-12.146L126.725,346.261z M22.514,487.309l-4.052-28.369l18.063-3.618l17.976,17.976l-3.609,18.071 L22.514,487.309z M63.922,458.177l-12.276-12.267l24.543-24.543l12.267,12.267L63.922,458.177z M125.268,445.909l-18.392-18.392l0,0 l-24.543-24.543l0,0l-18.41-18.418l12.267-12.276l6.134,6.134l0,0l49.078,49.078l6.134,6.134L125.268,445.909z M137.535,409.099 l-12.267-12.267l22.557-22.557c4.043,4.156,8.337,8.051,12.866,11.669L137.535,409.099z M319.012,386.126l-62.994,31.492 l-62.994-31.501c-41.261-20.448-67.305-62.586-67.141-108.636V130.048l130.134-40.663l130.134,40.663v147.433 c0.165,46.05-25.879,88.188-67.141,108.636L319.012,386.126L319.012,386.126z M351.372,385.978 c4.529-3.618,8.823-7.513,12.866-11.669l22.557,22.557l-12.293,12.233L351.372,385.978z M386.768,445.918l-12.267-12.276 l6.134-6.134l49.078-49.078l0,0l6.134-6.134l12.267,12.276l-18.401,18.401l0,0l-24.543,24.543l0,0L386.768,445.918z  M435.846,421.375l24.543,24.543l-12.276,12.267l-24.535-24.543L435.846,421.375z M489.522,487.309l-28.378,4.052l-3.609-18.063 l17.976-17.976l18.071,3.618L489.522,487.309z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 73.83,
  y: 184.4,
  width: 17.351,
  height: 17.351
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 73.83,
  y: 219.059,
  width: 17.351,
  height: 95.432
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 420.855,
  y: 297.227,
  width: 17.351,
  height: 17.351
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 420.855,
  y: 184.4,
  width: 17.351,
  height: 95.432
});

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

const SvgShield = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512.002 512.002",
  style: {
    enableBackground: "new 0 0 512.002 512.002"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
  x: 83.408,
  y: 357.06,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 461.293 627.153)",
  style: {
    fill: "#FBB03B"
  },
  width: 34.702,
  height: 104.106
}), /*#__PURE__*/React.createElement("rect", {
  x: 44.027,
  y: 422.416,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 430.5518 701.1947)",
  style: {
    fill: "#8C6239"
  },
  width: 52.053,
  height: 34.702
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#29ABE2"
  },
  points: "39.379,445.901 8.711,452.034 14.845,494.979 57.789,501.112 63.922,470.444 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#CCCCCC"
  },
  points: "350.825,109.92 423.83,36.915 472.908,36.915 472.908,85.993 394.828,164.073  173.947,384.946 137.535,421.366 88.457,372.288 129.05,331.695 "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#B3B3B3"
  },
  points: "472.908,36.915 423.83,36.915 88.457,372.288 113,396.823 148.137,361.686 388.217,121.606  472.908,36.915 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 423.83,
  y: 36.915,
  style: {
    fill: "#999999"
  },
  width: 49.078,
  height: 49.078
}), /*#__PURE__*/React.createElement("rect", {
  x: 359.227,
  y: 391.758,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 991.3823 407.5735)",
  style: {
    fill: "#FBB03B"
  },
  width: 104.106,
  height: 34.702
}), /*#__PURE__*/React.createElement("rect", {
  x: 424.621,
  y: 413.746,
  transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1065.4596 438.2181)",
  style: {
    fill: "#8C6239"
  },
  width: 34.702,
  height: 52.053
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#29ABE2"
  },
  points: "472.657,445.901 503.325,452.034 497.191,494.979 454.247,501.112 448.113,470.444 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#CCCCCC"
  },
  points: "161.211,109.92 88.205,36.915 39.128,36.915 39.128,85.993 117.208,164.073 338.089,384.946  374.501,421.366 423.579,372.288 382.985,331.695 "
}), /*#__PURE__*/React.createElement("polyline", {
  style: {
    fill: "#B3B3B3"
  },
  points: "39.128,36.915 88.205,36.915 423.579,372.288 399.035,396.823 363.899,361.686  123.819,121.606 39.128,36.915 "
}), /*#__PURE__*/React.createElement("rect", {
  x: 39.128,
  y: 36.915,
  style: {
    fill: "#999999"
  },
  width: 49.078,
  height: 49.078
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#FBB03B"
  },
  points: "327.592,106.32 360.125,10.888 325.423,10.888 299.396,45.59 273.369,10.888 238.667,10.888  212.64,45.59 186.613,10.888 151.911,10.888 184.444,106.32 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#0071BC"
  },
  d: "M322.889,393.882l-66.872,33.436l-66.872-33.436c-44.089-22.045-71.938-67.106-71.938-116.401 v-153.81l138.81-43.378l138.81,43.378v153.81C394.828,326.776,366.979,371.837,322.889,393.882z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#29ABE2"
  },
  points: "256.018,114.995 151.911,149.698 151.911,245.13 256.018,245.13 "
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    fill: "#E6E6E6"
  },
  points: "360.125,245.13 360.125,149.698 256.018,114.995 256.018,245.13 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#29ABE2"
  },
  d: "M256.018,245.13v138.81l56.149-28.074c29.393-14.697,47.959-44.731,47.959-77.595V245.13 L256.018,245.13L256.018,245.13z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#E6E6E6"
  },
  d: "M151.911,245.13v33.141c0,32.863,18.566,62.898,47.959,77.595l56.149,28.074V245.13L151.911,245.13 L151.911,245.13z"
}), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.94eb45a9.svg";
export { ForwardRef as ReactComponent };